/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const AutoActionLogState = Record({
  id: null,
  reservation_id: null,
  auto_action_mail_id: null,
  auto_action_task_id: null,
  title: '',
  mail_to: '',
  mail_from: '',
  mail_reply_to: '',
  mail_cc: '',
  mail_bcc: '',
  execute_at: null,
  expire_at: null,
  status: null,
  error_message: '',
  auto_action_mail_content: null
})

export { AutoActionLogState }
